import { ReactNode } from 'react';
import styled from 'styled-components';

const MarkdownTable = ({ children }: { children: ReactNode }) => {
  return <Table>{children}</Table>;
};

const Table = styled.table`
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: left;

  box-shadow: none !important;

  th {
    padding: 20px;
    font-weight: 800;
    background-color: #f1ebe3;
  }
  td {
    padding: 20px;
  }

  & tbody > tr {
    box-shadow: none !important;
  }
`;

export default MarkdownTable;
